import { Builder } from "../interfaces/builder.js";
/**
 * Create a signal with a state and actions for managing this state
 * @param options
 * @returns
 */
var createSignal = function (options) {
    var actions = [];
    var operations = [];
    var asyncActions = [];
    // Convert the actions object to an array
    var actionsTable = Object.entries(options.actions || {});
    for (var _i = 0, actionsTable_1 = actionsTable; _i < actionsTable_1.length; _i++) {
        var action = actionsTable_1[_i];
        actions.push({
            type: "".concat(options.name, "/").concat(action[0]),
            handler: action[1],
        });
    }
    // Convert the operations object to an array
    var operationsTable = Object.entries(options.operations || {});
    for (var _a = 0, operationsTable_1 = operationsTable; _a < operationsTable_1.length; _a++) {
        var operation = operationsTable_1[_a];
        operations.push({
            type: "".concat(options.name, "/").concat(operation[0]),
            handler: operation[1],
        });
    }
    // Convert the async Actions object to an array
    var builder = new Builder();
    var asyncActionsTable = Object.entries(options.asyncActions ? options.asyncActions(builder) : {});
    for (var _b = 0, asyncActionsTable_1 = asyncActionsTable; _b < asyncActionsTable_1.length; _b++) {
        var action = asyncActionsTable_1[_b];
        asyncActions.push({
            type: "".concat(options.name, "/").concat(action[0]),
            steps: action[1],
        });
    }
    // Create a signal
    var signal = {
        name: options.name,
        state: options.state,
        actions: actions,
        operations: operations,
        asyncActions: asyncActions,
    };
    return signal;
};
export default createSignal;
